import _ from 'lodash';
import interceptor from 'rest/interceptor';

const FailureCodesInterceptor = interceptor({
  init: config => config,
  response: (response, config) => {
    if (response.status && _.includes(config.failureCodes, response.status.code)) {
      return Promise.reject(response);
    }
    return response;
  }
});

export default FailureCodesInterceptor;



/** WEBPACK FOOTER **
 ** ./src/rest/FailureCodesInterceptor.js
 **/